// Copyright 2024 Tobias Olenyi.
// SPDX-License-Identifier: Apache-2.0

export const prerender = true;
